import { Box, Tab, Tabs, Typography } from '@mui/material'

const AddonsSegmentHeader = ({
    segments,
    selectedSegmentIndex,
    setSelectedSegmentIndex
}: {
    segments: { from: string; to: string }[]
    selectedSegmentIndex: number
    setSelectedSegmentIndex: (index: number) => void
}) => {
    return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, mt: 1 }}>
            <Tabs
                value={selectedSegmentIndex}
                onChange={(_, newValue) => setSelectedSegmentIndex(newValue)}
                aria-label="journey segments"
            >
                {segments.map((segment, index) => (
                    <Tab
                        key={index}
                        label={
                            <Box sx={{ textAlign: 'left' }}>
                                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                    {segment.from} → {segment.to}
                                </Typography>
                            </Box>
                        }
                        sx={{ alignItems: 'flex-start', textTransform: 'none' }}
                    />
                ))}
            </Tabs>
        </Box>
    )
}

export default AddonsSegmentHeader
